import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { selectComponents } from '@rocketlane/ui';
import styled, { css } from 'styled-components';
import { Avatar } from 'components/atoms/avatar';
/**
 * Shared flex-safe option-layout primitives for `@rocketlane/ui` Select options.
 *
 * The package renders each option with a flex `.ozone-select__option`, so custom
 * options must lay their content out as flex children (an antd-`List` Item
 * collapses). Several pickers (squad-picker, assignee-picker, the automations
 * assignee/email inputs, atoms custom-components) had byte-identical copies of
 * these row/body wrappers — collapsed here.
 *
 * The per-row `Description` (secondary line under the option label) is shared
 * here too — it must match the package's native user-option description
 * (12px / `--text-tertiary`), which is what the task-drawer assignee picker uses.
 */ /** Preserve the package's 48px two-line user-row contract in unavoidable
 * custom Option renderers without wrapping react-select's theme-bearing Option. */ export const getFlexUserOptionClassName = (className, hasDescription)=>`${className !== null && className !== void 0 ? className : ''}${hasDescription ? ' !py-[7px]' : ''}`;
export const FlexUserOptionRow = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-03);
  flex: 1;
  min-width: 0;
  ${({ $isInactive })=>$isInactive ? css`
          color: var(--gray-50);
        ` : css``};
`;
export const FlexUserOptionBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;
export const FlexUserOptionDescription = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: var(--text-tertiary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const FlexUserAvatar = ({ data, includeUserStatus = true })=>/*#__PURE__*/ _jsx(Avatar, {
        name: data.__isNew__ ? data.value.toString() : data.label,
        src: data.imageUrl,
        companyLogoUrl: data.logoUrl,
        userStatus: includeUserStatus ? data.userStatus : undefined,
        size: 20,
        initialsFontSize: 10
    });
/**
 * Package-composed flex frame shared by the remaining rich user option
 * adapters. Domain wrappers supply only their avatar/title/description slots.
 */ export const FlexUserOption = ({ optionProps, avatar, title, description, isInactive = false })=>{
    const hasDescription = Boolean(description);
    const packageOptionData = {
        ...optionProps.data,
        description: undefined,
        icon: undefined
    };
    return /*#__PURE__*/ _jsx(selectComponents.Option, {
        ...optionProps,
        data: packageOptionData,
        className: getFlexUserOptionClassName(optionProps.className, hasDescription),
        children: /*#__PURE__*/ _jsxs(FlexUserOptionRow, {
            $isInactive: isInactive,
            children: [
                avatar,
                /*#__PURE__*/ _jsxs(FlexUserOptionBody, {
                    children: [
                        title,
                        hasDescription ? /*#__PURE__*/ _jsx(FlexUserOptionDescription, {
                            children: description
                        }) : null
                    ]
                })
            ]
        })
    });
};
